import { useAuthInfiniteList } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { EventApi } from 'api';
import { IEvent, SearchEventFilterType } from 'types';
import { KEY } from './keys';

function useGetInfinite(filter: SearchEventFilterType, size = 30) {
  return useAuthInfiniteList<IEvent>(
    [...getQueryKeys([KEY]).lists(), 'infinite', { ...filter, size }],
    (page) => EventApi.getAll({ ...filter, page, size }),
  );
}

export default useGetInfinite;
